import CityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { forestGroveConfig } from "./data";

export default function ForestGrovePage() {
  return <CityPageTemplate config={forestGroveConfig} />;
}